import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const AudienceSection = ({ audienceLabel, onSelectClick, isLoading, error, userCount }) => (
  <section className='announcements-section'>
    <div className='announcements-field'>
      <label className='announcements-label'>
        Audience <span className='announcements-label-required'>*</span>
      </label>
      <div
        role='button'
        tabIndex={0}
        className={cn('announcements-audience-input', { 'is-placeholder': !audienceLabel })}
        onClick={onSelectClick}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelectClick();
          }
        }}
      >
        {audienceLabel || 'Click to select audience'}
      </div>
      {isLoading && <div className='announcements-audience-meta'>Loading audience count…</div>}
      {error && <div className='announcements-audience-meta announcements-audience-meta-error'>{error}</div>}
      {!isLoading && !error && userCount != null && (
        <div className='announcements-audience-meta'>
          {userCount} user{userCount !== 1 ? 's' : ''} match this audience
        </div>
      )}
    </div>
  </section>
);

AudienceSection.propTypes = {
  audienceLabel: PropTypes.string.isRequired,
  onSelectClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  userCount: PropTypes.number
};

export default AudienceSection;
